import axios from "axios";
import store from './../index'

// «Аналитика»: «Общие показатели», «Закуп аптек», «Дистрибьюторы» (PurchaseAnalytics/*) поверх витрины закупок,
// только заказы сайта. У каждого отчёта своя выгрузка Excel.

async function downloadXlsx(request, fileName) {
  try {
    const { data } = await request();

    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    let text = 'Не удалось сформировать отчёт';
    try {
      const body = error.response?.data;
      if (body instanceof Blob) {
        text = JSON.parse(await body.text()).error || text;
      } else if (body?.error) {
        text = body.error;
      }
    } catch (parseError) {
      window.console.log(parseError);
    }
    store.commit('SET_SNACKBAR', { text, timeout: 7500, color: 'error', linkText: '', show: true });
    throw error;
  }
}

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    PURCHASE_FILTER_OPTIONS: async () => (await axios.get('/PurchaseAnalytics/GetFilterOptionsAsync')).data,

    PURCHASE_GENERAL: async (_, search) => (await axios.post('/PurchaseAnalytics/GetGeneralAsync', search || {})).data,
    PURCHASE_PHARMACIES: async (_, search) => (await axios.post('/PurchaseAnalytics/GetPharmaciesAsync', search || {})).data,
    PURCHASE_DISTRIBUTORS: async (_, search) => (await axios.post('/PurchaseAnalytics/GetDistributorsAsync', search || {})).data,

    DOWNLOAD_PURCHASE_GENERAL: (_, search) => downloadXlsx(
      () => axios.post('/PurchaseAnalytics/DownloadGeneralAsync', search || {}, { responseType: 'blob' }), 'GeneralIndicators.xlsx'),
    DOWNLOAD_PURCHASE_PHARMACIES: (_, search) => downloadXlsx(
      () => axios.post('/PurchaseAnalytics/DownloadPharmaciesAsync', search || {}, { responseType: 'blob' }), 'PharmacyPurchases.xlsx'),
    DOWNLOAD_PURCHASE_DISTRIBUTORS: (_, search) => downloadXlsx(
      () => axios.post('/PurchaseAnalytics/DownloadDistributorsAsync', search || {}, { responseType: 'blob' }), 'Distributors.xlsx'),
  }
};
